import React, { useEffect, useState } from 'react';
import { mortgageCalcEnabled } from '../util/config';
import useMonthlyPaymentsStore from '../store/useMonthlyPaymentsStore';
import { GetMonthlyPayment } from '../util/api-helpers';
function MonthlyPayment({ id, estimatedPrice, mortgageCalcModel, estimatedMonthlyPaymentModalUrl, isUsingMortgageCalc }) {
    const { isMonthlyPaymentApiReady, setMonthlyPayment, monthlyPayments } = useMonthlyPaymentsStore(["isMonthlyPaymentApiReady", "setMonthlyPayment", "monthlyPayments"]);
    const [isMonthlyPaymentLoading, setIsMonthlyPaymentLoading] = useState(true);
    useEffect(() => {
        loadMonthlyPayments();
    }, [isMonthlyPaymentApiReady]);
    const loadMonthlyPayments = (async () => {
        if (!isUsingMortgageCalc || !mortgageCalcModel) {
            setIsMonthlyPaymentLoading(false);
        }
        else if (isMonthlyPaymentApiReady) {
            if (id && mortgageCalcModel && !monthlyPayments.get(id)) {
                try {
                    let monthlyPayment = await GetMonthlyPayment(mortgageCalcModel);
                    if (monthlyPayment > 0)
                        setMonthlyPayment(id, monthlyPayment);
                }
                catch (ex) {
                    console.log(`Loan Calc Error - Item id: ${id}`);
                }
            }
            setIsMonthlyPaymentLoading(false);
        }
    });
    const monthlyPayment = (amount) => {
        return parseFloat((amount || '0')?.replace(/\,/g, ''))?.toLocaleString('us-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    };
    const monthlyPaymentHandler = (e) => {
        e.stopPropagation();
        if (estimatedMonthlyPaymentModalUrl) {
            const func = new Function(estimatedMonthlyPaymentModalUrl);
            func();
        }
    };
    return React.createElement("div", { className: "lot-card__monthly-payment" },
        React.createElement("small", { className: "lot-card__monthly-payment-subtext" }, "Est."),
        React.createElement("div", { className: "lot-card__monthly-payment-button__container" }, mortgageCalcEnabled && mortgageCalcModel ? (React.createElement("span", { className: "lot-card__monthly-payment-price-only", id: "block-listing" + id },
            isMonthlyPaymentLoading &&
                React.createElement("span", { id: "mort-calc-spinner" + id, className: "spinner-border", role: "status" },
                    React.createElement("span", { className: "sr-only" }, "Loading")),
            !isMonthlyPaymentLoading &&
                React.createElement("button", { className: "monthly-payment lot-card__monthly-payment-button bg-transparent", onMouseUp: monthlyPaymentHandler, "data-gtm": true, "data-mortgage-calc": true }, id && monthlyPayments.get(id) && monthlyPayments.get(id) > 0 ? monthlyPayment(monthlyPayments.get(id)?.toString()) : monthlyPayment(estimatedPrice)))) : (React.createElement("span", { className: 'lot-card__monthly-payment-price-only' }, monthlyPayment(estimatedPrice)))),
        React.createElement("small", { className: "lot-card__monthly-payment-subtext" }, "/mo"));
}
export default MonthlyPayment;
